import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface AddToDockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  appName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function AddToDockDialog({
  open,
  onOpenChange,
  appName,
  onConfirm,
  onCancel,
}: AddToDockDialogProps) {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  const handleCancel = () => {
    onCancel();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl md:max-w-2xl w-full bg-gradient-to-br from-background/95 to-background/90 backdrop-blur-xl border border-white/10 shadow-2xl">
        <DialogHeader className="space-y-4">
          <DialogTitle className="text-xl font-semibold text-center">
            Add to Dock
          </DialogTitle>
          <DialogDescription className="text-center text-base leading-relaxed">
            Would you like to add <span className="font-medium text-foreground">{appName}</span> to your dock permanently? 
            This will keep the app easily accessible even when it's not running.
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter className="flex flex-row justify-center gap-4 pt-4">
          <Button 
            variant="secondary" 
            onClick={handleCancel}
            className="min-w-24"
          >
            Cancel
          </Button>
          <Button 
            variant="success"
            onClick={handleConfirm}
            className="min-w-24"
          >
            Add to Dock
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}